'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectUserLocation = exports.selectDistanceUnit = exports.selectUserSelectedLocation = exports.selectUserLocale = exports.selectUserDetectedLocation = exports.selectMeasurementSystem = exports.selectLocaleInfo = exports.selectCountry = exports.setUserSelectedLocation = exports.setUserDetectedLocation = exports.setCountry = exports.setLocaleInfo = exports.setUserLocale = exports.setLocale = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.default = reducer;

var _countriesServed = require('constants/countries-served');

var _measurement = require('constants/measurement');

var _deep = require('helpers/deep');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_LOCALE = 'classpass/locale/SET_LOCALE';
var SET_USER_LOCALE = 'classpass/locale/SET_USER_LOCALE';
var SET_LOCALE_INFO = 'classpass/locale/SET_LOCALE_INFO';
var SET_COUNTRY = 'classpass/locale/SET_COUNTRY';
var SET_USER_DETECTED_LOCATION = 'classpass/locale/SET_USER_DETECTED_LOCATION';
var SET_USER_SELECTED_LOCATION = 'classpass/locale/SET_USER_SELECTED_LOCATION';

var setLocale = exports.setLocale = function setLocale(locale) {
  return { type: SET_LOCALE, data: locale };
};
var setUserLocale = exports.setUserLocale = function setUserLocale(locale) {
  return { type: SET_USER_LOCALE, data: locale };
};
var setLocaleInfo = exports.setLocaleInfo = function setLocaleInfo(addressRequirements) {
  return { type: SET_LOCALE_INFO, data: addressRequirements };
};
var setCountry = exports.setCountry = function setCountry(country, continent) {
  return { type: SET_COUNTRY, data: { country: country, continent: continent } };
};
var setUserDetectedLocation = exports.setUserDetectedLocation = function setUserDetectedLocation(lat, lon, accuracy) {
  return { type: SET_USER_DETECTED_LOCATION, data: { lat: lat, lon: lon, accuracy: accuracy } };
};
var setUserSelectedLocation = exports.setUserSelectedLocation = function setUserSelectedLocation(lat, lon) {
  return { type: SET_USER_SELECTED_LOCATION, data: { lat: lat, lon: lon } };
};

var selectCountry = exports.selectCountry = _deep.deepExtract.bind(null, 'locale.country');
var selectLocaleInfo = exports.selectLocaleInfo = _deep.deepExtract.bind(null, 'locale.addressRequirements');
var selectMeasurementSystem = exports.selectMeasurementSystem = _deep.deepExtract.bind(null, 'locale.measurementSystem');
var selectUserDetectedLocation = exports.selectUserDetectedLocation = _deep.deepExtract.bind(null, 'locale.userDetectedLocation');
var selectUserLocale = exports.selectUserLocale = _deep.deepExtract.bind(null, 'locale.userLocale');
var selectUserSelectedLocation = exports.selectUserSelectedLocation = _deep.deepExtract.bind(null, 'locale.userSelectedLocation');

var selectDistanceUnit = exports.selectDistanceUnit = function selectDistanceUnit(state) {
  return selectMeasurementSystem(state) === _measurement.SYSTEMS.imperial ? _measurement.DISTANCE_UNITS.mi : _measurement.DISTANCE_UNITS.km;
};
var selectUserLocation = exports.selectUserLocation = function selectUserLocation(state) {
  return selectUserSelectedLocation(state) || selectUserDetectedLocation(state);
};

var initialState = {
  continent: '',
  country: '',
  exactCountry: '',
  locale: 'en-US',
  addressRequirements: {},
  measurementSystem: _measurement.SYSTEMS.metric,
  userDetectedLocation: null,
  userSelectedLocation: null
};

var closestServedCountry = function closestServedCountry(country, continent) {
  if ((0, _keys2.default)(_countriesServed.COUNTRY_CODE_TO_NAME).indexOf(country) !== -1) {
    return country;
  }
  if (continent === 'europe') {
    return 'GBR';
  }
  return 'USA';
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_COUNTRY:
      return (0, _extends3.default)({}, state, {
        exactCountry: action.data.country,
        continent: action.data.continent,
        country: closestServedCountry(action.data.country, action.data.continent),
        measurementSystem: action.data.country === 'USA' ? _measurement.SYSTEMS.imperial : _measurement.SYSTEMS.metric
      });
    case SET_USER_DETECTED_LOCATION:
      return (0, _extends3.default)({}, state, {
        userDetectedLocation: action.data
      });
    case SET_USER_SELECTED_LOCATION:
      return (0, _extends3.default)({}, state, {
        userSelectedLocation: action.data
      });
    case SET_LOCALE:
      return (0, _extends3.default)({}, state, {
        locale: action.data
      });
    case SET_USER_LOCALE:
      return (0, _extends3.default)({}, state, {
        userLocale: action.data
      });
    case SET_LOCALE_INFO:
      return (0, _extends3.default)({}, state, {
        addressRequirements: action.data
      });
    default:
      return state;
  }
}